import { ActionTree, ActionContext } from 'vuex'
import { IAppState, IRootState } from '@/@types'

const actions: ActionTree<IAppState, IRootState> = {
  isAppLoading: (context: ActionContext<IAppState, IRootState>, payload: boolean) => {
    context.commit('IS_APP_LOADING_UPDATED', payload)
  },
  setSubscriptionView: (context: ActionContext<IAppState, IRootState>, payload: string) => {
    context.commit('SUBSCRIPTION_VIEW_SELECT_UPDATED', payload)
  },
  setIsComponentLoading: (context: ActionContext<IAppState, IRootState>, payload: boolean) => {
    context.commit('IS_COMPONENT_LOADING_UPDATED', payload)
  },
  setError: (context: ActionContext<IAppState, IRootState>, error: string) => {
    context.commit('APP_ERROR_UPDATED', error)
  },
  setNotification: (context: ActionContext<IAppState, IRootState>, notification: string) => {
    context.commit('APP_NOTIFICATION_UPDATED', notification)
  },
  setWarning: (context: ActionContext<IAppState, IRootState>, warning: string) => {
    context.commit('APP_WARNING_UPDATED', warning)
  },
  setSuccess: (context: ActionContext<IAppState, IRootState>, success: string) => {
    context.commit('APP_SUCCESS_UPDATED', success)
  },
  setIsSignInModalShown: (context: ActionContext<IAppState, IRootState>, payload: boolean) => {
    context.commit('IS_SIGN_IN_MODAL_SHOWN_UPDATED', payload)
  },
  setGenericBackground(context: ActionContext<IAppState, IRootState>, payload: boolean) {
    context.commit('SHOW_GENERIC_BACKGROUND_UPDATED', payload)
  },
}

export default actions
